import React from 'react';
import { Col, Row } from 'antd';
import CustomImage from '../Antd/Image'
export default function Loading(props) {
	return (
		<>
			<Row justify={'center'} style={{ height: "100vh",alignItems: "center" }}>
				<Col align={'center'}>
					<CustomImage 
						src='https://storage.googleapis.com/tirx-resources-production/8039fc50-9ea8-4790-a6ce-1fe3a62d6710.gif'
						alt='loading'
						width={250}
						preview={false}
					/>
				</Col>
			</Row>
		</>
	);
}
